class List {
  static update(list, data, key = null) {
    const matchingKey = key || 'id';
    return list.map((item) => {
      if (item[matchingKey] === data[matchingKey]) {
        return data;
      }
      return item;
    });
  }

  static new(list, data) {
    list.unshift(data);
    return list;
  }

  static appendAtEnd(list, data) {
    list.push(data);
    return list;
  }
}

export default List;
